export const basicUrl='https://digital-server.onrender.com'


export const userId=JSON?.parse(localStorage?.getItem('user'))?.userId